var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-position--components"},[_c('i',{staticClass:"iconfont icon-wushuju"}),_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }